var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgAssumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#E94057"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.496 34.184L49.32 31.656C48.904 31.176 48.568 30.28 48.568 29.64V26.92C48.568 25.224 47.176 23.832 45.48 23.832H42.76C42.136 23.832 41.224 23.496 40.744 23.08L38.216 20.904C37.112 19.96 35.304 19.96 34.184 20.904L31.672 23.096C31.192 23.496 30.28 23.832 29.656 23.832H26.888C25.192 23.832 23.8 25.224 23.8 26.92V29.656C23.8 30.28 23.464 31.176 23.064 31.656L20.904 34.2C19.976 35.304 19.976 37.096 20.904 38.2L23.064 40.744C23.464 41.224 23.8 42.12 23.8 42.744V45.48C23.8 47.176 25.192 48.568 26.888 48.568H29.656C30.28 48.568 31.192 48.904 31.672 49.32L34.2 51.496C35.304 52.44 37.112 52.44 38.232 51.496L40.76 49.32C41.24 48.904 42.136 48.568 42.776 48.568H45.496C47.192 48.568 48.584 47.176 48.584 45.48V42.76C48.584 42.136 48.92 41.224 49.336 40.744L51.512 38.216C52.44 37.112 52.44 35.288 51.496 34.184ZM42.856 33.176L35.128 40.904C34.904 41.128 34.6 41.256 34.28 41.256C33.96 41.256 33.656 41.128 33.432 40.904L29.56 37.032C29.096 36.568 29.096 35.8 29.56 35.336C30.024 34.872 30.792 34.872 31.256 35.336L34.28 38.36L41.16 31.48C41.624 31.016 42.392 31.016 42.856 31.48C43.32 31.944 43.32 32.712 42.856 33.176Z",
    fill: "url(#paint0_linear_13_2503)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_2503",
    x1: -10.5269,
    y1: 55.2686,
    x2: 66.1512,
    y2: 25.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAssumption);
export default __webpack_public_path__ + "static/media/img-assumption.c46ebad69288a03372764e566b3fde5a.svg";
export { ForwardRef as ReactComponent };